import { DocumentDownload, Edit } from "iconsax-reactjs";

export default function EventActionExtra() {

  return (
    <div className="flex items-center justify-center gap-1">
      <button
         type="button"
        className="p-2 rounded-lg text-gray-600 hover:bg-primaryVar-100 hover:text-primaryVar transition-colors h-7 w-7 cursor-not-allowed"
        title=" (فعلا در دسترس نمیباشد)"
      >
        <Edit
          variant="Outline"
          size="14"
        />
      </button>
      {/* <button
        disabled={true}
        type="button"
        className="p-2 rounded-lg text-gray-600 hover:bg-primaryVar-100 hover:text-primaryVar transition-colors h-7 w-7 cursor-not-allowed"
        title="دانلود فایل اکسل (فعلا در دسترس نمیباشد)"
      >
        <DocumentDownload
          variant="Outline"
          size="14"
        />
      </button> */}
    </div>
  );
};